@file:OptIn(InternalResourceApi::class)

package com.karyadina.common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.karyadina.common.generated.resources/"

@delegate:ResourceContentHash(349_602_171)
internal val Res.string.about_desc: StringResource by lazy {
      StringResource("string:about_desc", "about_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 26),
      ))
    }

@delegate:ResourceContentHash(349_602_171)
internal val Res.string.about_screen_title: StringResource by lazy {
      StringResource("string:about_screen_title", "about_screen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 69, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37, 34),
      ))
    }

@delegate:ResourceContentHash(-189_572_439)
internal val Res.string.active: StringResource by lazy {
      StringResource("string:active", "active", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 136, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72, 22),
      ))
    }

@delegate:ResourceContentHash(654_032_960)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 175, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95, 28),
      ))
    }

@delegate:ResourceContentHash(-1_529_159_950)
internal val Res.string.app_subtitle: StringResource by lazy {
      StringResource("string:app_subtitle", "app_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 204, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 124, 44),
      ))
    }

@delegate:ResourceContentHash(822_984_965)
internal val Res.string.back_string: StringResource by lazy {
      StringResource("string:back_string", "back_string", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 281, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169, 27),
      ))
    }

@delegate:ResourceContentHash(960_253_845)
internal val Res.string.btn_add: StringResource by lazy {
      StringResource("string:btn_add", "btn_add", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 317, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197, 19),
      ))
    }

@delegate:ResourceContentHash(-916_064_142)
internal val Res.string.cat_doc_desc: StringResource by lazy {
      StringResource("string:cat_doc_desc", "cat_doc_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 357, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217, 48),
      ))
    }

@delegate:ResourceContentHash(100_963_380)
internal val Res.string.cat_doc_title: StringResource by lazy {
      StringResource("string:cat_doc_title", "cat_doc_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 446, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266, 41),
      ))
    }

@delegate:ResourceContentHash(-1_357_061_578)
internal val Res.string.cat_prod_desc: StringResource by lazy {
      StringResource("string:cat_prod_desc", "cat_prod_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 500, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308, 53),
      ))
    }

@delegate:ResourceContentHash(1_324_500_096)
internal val Res.string.cat_prod_title: StringResource by lazy {
      StringResource("string:cat_prod_title", "cat_prod_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 606, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 362, 38),
      ))
    }

@delegate:ResourceContentHash(-774_737_417)
internal val Res.string.cat_util_desc: StringResource by lazy {
      StringResource("string:cat_util_desc", "cat_util_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 645, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 49),
      ))
    }

@delegate:ResourceContentHash(-1_651_263_392)
internal val Res.string.cat_util_title: StringResource by lazy {
      StringResource("string:cat_util_title", "cat_util_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 755, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 451, 34),
      ))
    }

@delegate:ResourceContentHash(-1_770_441_940)
internal val Res.string.color_blue: StringResource by lazy {
      StringResource("string:color_blue", "color_blue", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 790, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 486, 26),
      ))
    }

@delegate:ResourceContentHash(-1_801_830_175)
internal val Res.string.color_cyan: StringResource by lazy {
      StringResource("string:color_cyan", "color_cyan", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 825, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 513, 26),
      ))
    }

@delegate:ResourceContentHash(1_660_470_694)
internal val Res.string.color_green: StringResource by lazy {
      StringResource("string:color_green", "color_green", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 864, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 540, 27),
      ))
    }

@delegate:ResourceContentHash(548_240_111)
internal val Res.string.color_orange: StringResource by lazy {
      StringResource("string:color_orange", "color_orange", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 896, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 568, 28),
      ))
    }

@delegate:ResourceContentHash(-1_628_643_849)
internal val Res.string.color_purple: StringResource by lazy {
      StringResource("string:color_purple", "color_purple", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 941, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 597, 28),
      ))
    }

@delegate:ResourceContentHash(-693_056_228)
internal val Res.string.common_cancel: StringResource by lazy {
      StringResource("string:common_cancel", "common_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 986, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 626, 29),
      ))
    }

@delegate:ResourceContentHash(-1_926_829_440)
internal val Res.string.common_change: StringResource by lazy {
      StringResource("string:common_change", "common_change", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1044, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 656, 29),
      ))
    }

@delegate:ResourceContentHash(1_742_741_352)
internal val Res.string.common_close: StringResource by lazy {
      StringResource("string:common_close", "common_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1086, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 28),
      ))
    }

@delegate:ResourceContentHash(823_320_765)
internal val Res.string.common_delete: StringResource by lazy {
      StringResource("string:common_delete", "common_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1139, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 715, 29),
      ))
    }

@delegate:ResourceContentHash(799_394_332)
internal val Res.string.common_done: StringResource by lazy {
      StringResource("string:common_done", "common_done", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1181, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 745, 27),
      ))
    }

@delegate:ResourceContentHash(1_055_529_387)
internal val Res.string.common_edit: StringResource by lazy {
      StringResource("string:common_edit", "common_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1225, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 773, 27),
      ))
    }

@delegate:ResourceContentHash(-603_082_204)
internal val Res.string.common_mark_complete: StringResource by lazy {
      StringResource("string:common_mark_complete", "common_mark_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1293, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 801, 48),
      ))
    }

@delegate:ResourceContentHash(261_039_846)
internal val Res.string.common_mark_incomplete: StringResource by lazy {
      StringResource("string:common_mark_incomplete", "common_mark_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1390, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 850, 50),
      ))
    }

@delegate:ResourceContentHash(1_542_074_657)
internal val Res.string.common_ok: StringResource by lazy {
      StringResource("string:common_ok", "common_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1493, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 901, 21),
      ))
    }

@delegate:ResourceContentHash(-2_098_022_533)
internal val Res.string.common_open: StringResource by lazy {
      StringResource("string:common_open", "common_open", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1535, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 923, 27),
      ))
    }

@delegate:ResourceContentHash(669_512_561)
internal val Res.string.common_save: StringResource by lazy {
      StringResource("string:common_save", "common_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1575, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 951, 27),
      ))
    }

@delegate:ResourceContentHash(413_314_706)
internal val Res.string.common_share: StringResource by lazy {
      StringResource("string:common_share", "common_share", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1619, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 979, 28),
      ))
    }

@delegate:ResourceContentHash(1_351_423_326)
internal val Res.string.company_credit: StringResource by lazy {
      StringResource("string:company_credit", "company_credit", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1676, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1008, 66),
      ))
    }

@delegate:ResourceContentHash(1_446_178_525)
internal val Res.string.completed: StringResource by lazy {
      StringResource("string:completed", "completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1763, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1075, 29),
      ))
    }

@delegate:ResourceContentHash(-1_150_507_672)
internal val Res.string.daily_focus_due_today_format: StringResource by lazy {
      StringResource("string:daily_focus_due_today_format", "daily_focus_due_today_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1801, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1105, 56),
      ))
    }

@delegate:ResourceContentHash(-1_207_885_426)
internal val Res.string.daily_focus_overdue_format: StringResource by lazy {
      StringResource("string:daily_focus_overdue_format", "daily_focus_overdue_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1874, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1162, 50),
      ))
    }

@delegate:ResourceContentHash(783_953_711)
internal val Res.string.daily_focus_title: StringResource by lazy {
      StringResource("string:daily_focus_title", "daily_focus_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1945, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1213, 41),
      ))
    }

@delegate:ResourceContentHash(-1_901_246_304)
internal val Res.string.dot_separator: StringResource by lazy {
      StringResource("string:dot_separator", "dot_separator", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2011, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1255, 33),
      ))
    }

@delegate:ResourceContentHash(24_303_840)
internal val Res.string.explore_web_desc: StringResource by lazy {
      StringResource("string:explore_web_desc", "explore_web_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2045, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1289, 56),
      ))
    }

@delegate:ResourceContentHash(-1_028_892_204)
internal val Res.string.explore_web_title: StringResource by lazy {
      StringResource("string:explore_web_title", "explore_web_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2102, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1346, 45),
      ))
    }

@delegate:ResourceContentHash(-1_256_467_498)
internal val Res.string.feature_flashcards_desc: StringResource by lazy {
      StringResource("string:feature_flashcards_desc", "feature_flashcards_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2172, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1392, 87),
      ))
    }

@delegate:ResourceContentHash(-888_693_934)
internal val Res.string.feature_flashcards_title: StringResource by lazy {
      StringResource("string:feature_flashcards_title", "feature_flashcards_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2332, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1480, 48),
      ))
    }

@delegate:ResourceContentHash(1_637_362_436)
internal val Res.string.feature_img2pdf_desc: StringResource by lazy {
      StringResource("string:feature_img2pdf_desc", "feature_img2pdf_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2405, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1529, 92),
      ))
    }

@delegate:ResourceContentHash(-1_362_492_094)
internal val Res.string.feature_img2pdf_title: StringResource by lazy {
      StringResource("string:feature_img2pdf_title", "feature_img2pdf_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2566, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1622, 45),
      ))
    }

@delegate:ResourceContentHash(2_128_016_439)
internal val Res.string.feature_notes_desc: StringResource by lazy {
      StringResource("string:feature_notes_desc", "feature_notes_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2620, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1668, 70),
      ))
    }

@delegate:ResourceContentHash(-1_275_187_318)
internal val Res.string.feature_notes_title: StringResource by lazy {
      StringResource("string:feature_notes_title", "feature_notes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2779, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1739, 43),
      ))
    }

@delegate:ResourceContentHash(-1_770_303_985)
internal val Res.string.feature_planner_desc: StringResource by lazy {
      StringResource("string:feature_planner_desc", "feature_planner_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2851, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1783, 72),
      ))
    }

@delegate:ResourceContentHash(-957_464_209)
internal val Res.string.feature_planner_title: StringResource by lazy {
      StringResource("string:feature_planner_title", "feature_planner_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3020, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1856, 49),
      ))
    }

@delegate:ResourceContentHash(1_347_189_415)
internal val Res.string.feature_resizer_desc: StringResource by lazy {
      StringResource("string:feature_resizer_desc", "feature_resizer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3098, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1906, 88),
      ))
    }

@delegate:ResourceContentHash(81_854_208)
internal val Res.string.feature_resizer_title: StringResource by lazy {
      StringResource("string:feature_resizer_title", "feature_resizer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3243, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1995, 49),
      ))
    }

@delegate:ResourceContentHash(125_629_833)
internal val Res.string.feature_scanner_desc: StringResource by lazy {
      StringResource("string:feature_scanner_desc", "feature_scanner_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3293, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2045, 84),
      ))
    }

@delegate:ResourceContentHash(152_238_830)
internal val Res.string.feature_scanner_title: StringResource by lazy {
      StringResource("string:feature_scanner_title", "feature_scanner_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3502, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2130, 53),
      ))
    }

@delegate:ResourceContentHash(-1_197_673_054)
internal val Res.string.feature_timer_desc: StringResource by lazy {
      StringResource("string:feature_timer_desc", "feature_timer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3608, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2184, 74),
      ))
    }

@delegate:ResourceContentHash(1_110_436_851)
internal val Res.string.feature_timer_title: StringResource by lazy {
      StringResource("string:feature_timer_title", "feature_timer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3751, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2259, 43),
      ))
    }

@delegate:ResourceContentHash(628_035_498)
internal val Res.string.feature_tracker_desc: StringResource by lazy {
      StringResource("string:feature_tracker_desc", "feature_tracker_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3819, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2303, 80),
      ))
    }

@delegate:ResourceContentHash(-1_577_518_624)
internal val Res.string.feature_tracker_title: StringResource by lazy {
      StringResource("string:feature_tracker_title", "feature_tracker_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4028, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2384, 45),
      ))
    }

@delegate:ResourceContentHash(1_772_471_401)
internal val Res.string.feature_translator_desc: StringResource by lazy {
      StringResource("string:feature_translator_desc", "feature_translator_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4106, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2430, 79),
      ))
    }

@delegate:ResourceContentHash(842_719_209)
internal val Res.string.feature_translator_title: StringResource by lazy {
      StringResource("string:feature_translator_title", "feature_translator_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4270, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2510, 60),
      ))
    }

@delegate:ResourceContentHash(3_381_344)
internal val Res.string.header_alpha: StringResource by lazy {
      StringResource("string:header_alpha", "header_alpha", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4347, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2571, 36),
      ))
    }

@delegate:ResourceContentHash(-991_552_246)
internal val Res.string.help_btn_read_more: StringResource by lazy {
      StringResource("string:help_btn_read_more", "help_btn_read_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4384, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2608, 42),
      ))
    }

@delegate:ResourceContentHash(1_509_189_143)
internal val Res.string.help_desc: StringResource by lazy {
      StringResource("string:help_desc", "help_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4451, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2651, 25),
      ))
    }

@delegate:ResourceContentHash(1_181_826_208)
internal val Res.string.help_feature_flashcards_desc: StringResource by lazy {
      StringResource("string:help_feature_flashcards_desc", "help_feature_flashcards_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4493, 404),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2677, 172),
      ))
    }

@delegate:ResourceContentHash(-888_693_934)
internal val Res.string.help_feature_flashcards_title: StringResource by lazy {
      StringResource("string:help_feature_flashcards_title", "help_feature_flashcards_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4898, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2850, 53),
      ))
    }

@delegate:ResourceContentHash(-505_576_662)
internal val Res.string.help_feature_notes_desc: StringResource by lazy {
      StringResource("string:help_feature_notes_desc", "help_feature_notes_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4976, 383),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2904, 151),
      ))
    }

@delegate:ResourceContentHash(853_632_421)
internal val Res.string.help_feature_notes_title: StringResource by lazy {
      StringResource("string:help_feature_notes_title", "help_feature_notes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5360, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3056, 48),
      ))
    }

@delegate:ResourceContentHash(546_331_999)
internal val Res.string.help_feature_ocr_desc: StringResource by lazy {
      StringResource("string:help_feature_ocr_desc", "help_feature_ocr_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5441, 477),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3105, 169),
      ))
    }

@delegate:ResourceContentHash(1_634_287_178)
internal val Res.string.help_feature_ocr_title: StringResource by lazy {
      StringResource("string:help_feature_ocr_title", "help_feature_ocr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5919, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3275, 50),
      ))
    }

@delegate:ResourceContentHash(-1_788_714_871)
internal val Res.string.help_feature_pdf_desc: StringResource by lazy {
      StringResource("string:help_feature_pdf_desc", "help_feature_pdf_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5998, 697),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3326, 237),
      ))
    }

@delegate:ResourceContentHash(1_394_129)
internal val Res.string.help_feature_pdf_title: StringResource by lazy {
      StringResource("string:help_feature_pdf_title", "help_feature_pdf_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6696, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3564, 46),
      ))
    }

@delegate:ResourceContentHash(1_318_205_489)
internal val Res.string.help_feature_planner_desc: StringResource by lazy {
      StringResource("string:help_feature_planner_desc", "help_feature_planner_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6775, 405),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3611, 165),
      ))
    }

@delegate:ResourceContentHash(-613_941_800)
internal val Res.string.help_feature_planner_title: StringResource by lazy {
      StringResource("string:help_feature_planner_title", "help_feature_planner_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 7181, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3777, 54),
      ))
    }

@delegate:ResourceContentHash(-1_233_928_647)
internal val Res.string.help_feature_resizer_desc: StringResource by lazy {
      StringResource("string:help_feature_resizer_desc", "help_feature_resizer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 7276, 453),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3832, 197),
      ))
    }

@delegate:ResourceContentHash(-25_556_529)
internal val Res.string.help_feature_resizer_title: StringResource by lazy {
      StringResource("string:help_feature_resizer_title", "help_feature_resizer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 7730, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4030, 54),
      ))
    }

@delegate:ResourceContentHash(1_137_883_898)
internal val Res.string.help_feature_tasks_desc: StringResource by lazy {
      StringResource("string:help_feature_tasks_desc", "help_feature_tasks_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 7813, 487),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4085, 175),
      ))
    }

@delegate:ResourceContentHash(-1_732_996_755)
internal val Res.string.help_feature_tasks_title: StringResource by lazy {
      StringResource("string:help_feature_tasks_title", "help_feature_tasks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 8301, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4261, 48),
      ))
    }

@delegate:ResourceContentHash(-846_606_140)
internal val Res.string.help_feature_timer_desc: StringResource by lazy {
      StringResource("string:help_feature_timer_desc", "help_feature_timer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 8382, 475),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4310, 199),
      ))
    }

@delegate:ResourceContentHash(1_110_436_851)
internal val Res.string.help_feature_timer_title: StringResource by lazy {
      StringResource("string:help_feature_timer_title", "help_feature_timer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 8858, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4510, 48),
      ))
    }

@delegate:ResourceContentHash(-683_598_732)
internal val Res.string.help_feature_translator_desc: StringResource by lazy {
      StringResource("string:help_feature_translator_desc", "help_feature_translator_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 8931, 308),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4559, 148),
      ))
    }

@delegate:ResourceContentHash(1_870_113_914)
internal val Res.string.help_feature_translator_title: StringResource by lazy {
      StringResource("string:help_feature_translator_title", "help_feature_translator_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9240, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4708, 53),
      ))
    }

@delegate:ResourceContentHash(-2_077_609_596)
internal val Res.string.help_screen_desc: StringResource by lazy {
      StringResource("string:help_screen_desc", "help_screen_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9306, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4762, 88),
      ))
    }

@delegate:ResourceContentHash(278_397_662)
internal val Res.string.help_screen_title: StringResource by lazy {
      StringResource("string:help_screen_title", "help_screen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9503, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4851, 41),
      ))
    }

@delegate:ResourceContentHash(1_570_294_477)
internal val Res.string.history_clear_all: StringResource by lazy {
      StringResource("string:history_clear_all", "history_clear_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9581, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4893, 45),
      ))
    }

@delegate:ResourceContentHash(260_146_326)
internal val Res.string.history_dialog_clear_msg: StringResource by lazy {
      StringResource("string:history_dialog_clear_msg", "history_dialog_clear_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9667, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4939, 88),
      ))
    }

@delegate:ResourceContentHash(1_570_296_771)
internal val Res.string.history_dialog_clear_title: StringResource by lazy {
      StringResource("string:history_dialog_clear_title", "history_dialog_clear_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9812, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5028, 54),
      ))
    }

@delegate:ResourceContentHash(1_858_041_080)
internal val Res.string.history_empty_msg: StringResource by lazy {
      StringResource("string:history_empty_msg", "history_empty_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9907, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5083, 89),
      ))
    }

@delegate:ResourceContentHash(-1_445_265_061)
internal val Res.string.history_empty_title: StringResource by lazy {
      StringResource("string:history_empty_title", "history_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10113, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5173, 47),
      ))
    }

@delegate:ResourceContentHash(-450_969_599)
internal val Res.string.history_filter_breaks: StringResource by lazy {
      StringResource("string:history_filter_breaks", "history_filter_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10213, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5221, 37),
      ))
    }

@delegate:ResourceContentHash(2_131_267_868)
internal val Res.string.history_filter_focus: StringResource by lazy {
      StringResource("string:history_filter_focus", "history_filter_focus", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10263, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5259, 36),
      ))
    }

@delegate:ResourceContentHash(-931_343_351)
internal val Res.string.history_subtitle: StringResource by lazy {
      StringResource("string:history_subtitle", "history_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10308, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5296, 44),
      ))
    }

@delegate:ResourceContentHash(1_730_524_453)
internal val Res.string.history_title: StringResource by lazy {
      StringResource("string:history_title", "history_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10357, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5341, 41),
      ))
    }

@delegate:ResourceContentHash(783_953_711)
internal val Res.string.home_daily_focus: StringResource by lazy {
      StringResource("string:home_daily_focus", "home_daily_focus", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10423, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5383, 40),
      ))
    }

@delegate:ResourceContentHash(-1_955_497_068)
internal val Res.string.home_doc_tools: StringResource by lazy {
      StringResource("string:home_doc_tools", "home_doc_tools", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10488, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5424, 54),
      ))
    }

@delegate:ResourceContentHash(1_969_071_020)
internal val Res.string.home_productivity: StringResource by lazy {
      StringResource("string:home_productivity", "home_productivity", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10555, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5479, 41),
      ))
    }

@delegate:ResourceContentHash(-2_003_841_912)
internal val Res.string.home_workspace_tools: StringResource by lazy {
      StringResource("string:home_workspace_tools", "home_workspace_tools", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10617, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5521, 40),
      ))
    }

@delegate:ResourceContentHash(2_013_586_516)
internal val Res.string.in_progress: StringResource by lazy {
      StringResource("string:in_progress", "in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10694, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5562, 35),
      ))
    }

@delegate:ResourceContentHash(253_988_384)
internal val Res.string.lang_english: StringResource by lazy {
      StringResource("string:lang_english", "lang_english", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10758, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5598, 32),
      ))
    }

@delegate:ResourceContentHash(2_030_412_576)
internal val Res.string.lang_hindi: StringResource by lazy {
      StringResource("string:lang_hindi", "lang_hindi", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10791, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5631, 50),
      ))
    }

@delegate:ResourceContentHash(-1_635_138_400)
internal val Res.string.licenses_desc: StringResource by lazy {
      StringResource("string:licenses_desc", "licenses_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10842, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5682, 49),
      ))
    }

@delegate:ResourceContentHash(-367_260_246)
internal val Res.string.licenses_title: StringResource by lazy {
      StringResource("string:licenses_title", "licenses_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10928, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5732, 34),
      ))
    }

@delegate:ResourceContentHash(-1_626_170_755)
internal val Res.string.message_no_sessions: StringResource by lazy {
      StringResource("string:message_no_sessions", "message_no_sessions", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10979, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5767, 51),
      ))
    }

@delegate:ResourceContentHash(44_754_670)
internal val Res.string.notes_action_image: StringResource by lazy {
      StringResource("string:notes_action_image", "notes_action_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11063, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5819, 38),
      ))
    }

@delegate:ResourceContentHash(560_023_093)
internal val Res.string.notes_action_scan: StringResource by lazy {
      StringResource("string:notes_action_scan", "notes_action_scan", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11130, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5858, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("about_desc", Res.string.about_desc)
  map.put("about_screen_title", Res.string.about_screen_title)
  map.put("active", Res.string.active)
  map.put("app_name", Res.string.app_name)
  map.put("app_subtitle", Res.string.app_subtitle)
  map.put("back_string", Res.string.back_string)
  map.put("btn_add", Res.string.btn_add)
  map.put("cat_doc_desc", Res.string.cat_doc_desc)
  map.put("cat_doc_title", Res.string.cat_doc_title)
  map.put("cat_prod_desc", Res.string.cat_prod_desc)
  map.put("cat_prod_title", Res.string.cat_prod_title)
  map.put("cat_util_desc", Res.string.cat_util_desc)
  map.put("cat_util_title", Res.string.cat_util_title)
  map.put("color_blue", Res.string.color_blue)
  map.put("color_cyan", Res.string.color_cyan)
  map.put("color_green", Res.string.color_green)
  map.put("color_orange", Res.string.color_orange)
  map.put("color_purple", Res.string.color_purple)
  map.put("common_cancel", Res.string.common_cancel)
  map.put("common_change", Res.string.common_change)
  map.put("common_close", Res.string.common_close)
  map.put("common_delete", Res.string.common_delete)
  map.put("common_done", Res.string.common_done)
  map.put("common_edit", Res.string.common_edit)
  map.put("common_mark_complete", Res.string.common_mark_complete)
  map.put("common_mark_incomplete", Res.string.common_mark_incomplete)
  map.put("common_ok", Res.string.common_ok)
  map.put("common_open", Res.string.common_open)
  map.put("common_save", Res.string.common_save)
  map.put("common_share", Res.string.common_share)
  map.put("company_credit", Res.string.company_credit)
  map.put("completed", Res.string.completed)
  map.put("daily_focus_due_today_format", Res.string.daily_focus_due_today_format)
  map.put("daily_focus_overdue_format", Res.string.daily_focus_overdue_format)
  map.put("daily_focus_title", Res.string.daily_focus_title)
  map.put("dot_separator", Res.string.dot_separator)
  map.put("explore_web_desc", Res.string.explore_web_desc)
  map.put("explore_web_title", Res.string.explore_web_title)
  map.put("feature_flashcards_desc", Res.string.feature_flashcards_desc)
  map.put("feature_flashcards_title", Res.string.feature_flashcards_title)
  map.put("feature_img2pdf_desc", Res.string.feature_img2pdf_desc)
  map.put("feature_img2pdf_title", Res.string.feature_img2pdf_title)
  map.put("feature_notes_desc", Res.string.feature_notes_desc)
  map.put("feature_notes_title", Res.string.feature_notes_title)
  map.put("feature_planner_desc", Res.string.feature_planner_desc)
  map.put("feature_planner_title", Res.string.feature_planner_title)
  map.put("feature_resizer_desc", Res.string.feature_resizer_desc)
  map.put("feature_resizer_title", Res.string.feature_resizer_title)
  map.put("feature_scanner_desc", Res.string.feature_scanner_desc)
  map.put("feature_scanner_title", Res.string.feature_scanner_title)
  map.put("feature_timer_desc", Res.string.feature_timer_desc)
  map.put("feature_timer_title", Res.string.feature_timer_title)
  map.put("feature_tracker_desc", Res.string.feature_tracker_desc)
  map.put("feature_tracker_title", Res.string.feature_tracker_title)
  map.put("feature_translator_desc", Res.string.feature_translator_desc)
  map.put("feature_translator_title", Res.string.feature_translator_title)
  map.put("header_alpha", Res.string.header_alpha)
  map.put("help_btn_read_more", Res.string.help_btn_read_more)
  map.put("help_desc", Res.string.help_desc)
  map.put("help_feature_flashcards_desc", Res.string.help_feature_flashcards_desc)
  map.put("help_feature_flashcards_title", Res.string.help_feature_flashcards_title)
  map.put("help_feature_notes_desc", Res.string.help_feature_notes_desc)
  map.put("help_feature_notes_title", Res.string.help_feature_notes_title)
  map.put("help_feature_ocr_desc", Res.string.help_feature_ocr_desc)
  map.put("help_feature_ocr_title", Res.string.help_feature_ocr_title)
  map.put("help_feature_pdf_desc", Res.string.help_feature_pdf_desc)
  map.put("help_feature_pdf_title", Res.string.help_feature_pdf_title)
  map.put("help_feature_planner_desc", Res.string.help_feature_planner_desc)
  map.put("help_feature_planner_title", Res.string.help_feature_planner_title)
  map.put("help_feature_resizer_desc", Res.string.help_feature_resizer_desc)
  map.put("help_feature_resizer_title", Res.string.help_feature_resizer_title)
  map.put("help_feature_tasks_desc", Res.string.help_feature_tasks_desc)
  map.put("help_feature_tasks_title", Res.string.help_feature_tasks_title)
  map.put("help_feature_timer_desc", Res.string.help_feature_timer_desc)
  map.put("help_feature_timer_title", Res.string.help_feature_timer_title)
  map.put("help_feature_translator_desc", Res.string.help_feature_translator_desc)
  map.put("help_feature_translator_title", Res.string.help_feature_translator_title)
  map.put("help_screen_desc", Res.string.help_screen_desc)
  map.put("help_screen_title", Res.string.help_screen_title)
  map.put("history_clear_all", Res.string.history_clear_all)
  map.put("history_dialog_clear_msg", Res.string.history_dialog_clear_msg)
  map.put("history_dialog_clear_title", Res.string.history_dialog_clear_title)
  map.put("history_empty_msg", Res.string.history_empty_msg)
  map.put("history_empty_title", Res.string.history_empty_title)
  map.put("history_filter_breaks", Res.string.history_filter_breaks)
  map.put("history_filter_focus", Res.string.history_filter_focus)
  map.put("history_subtitle", Res.string.history_subtitle)
  map.put("history_title", Res.string.history_title)
  map.put("home_daily_focus", Res.string.home_daily_focus)
  map.put("home_doc_tools", Res.string.home_doc_tools)
  map.put("home_productivity", Res.string.home_productivity)
  map.put("home_workspace_tools", Res.string.home_workspace_tools)
  map.put("in_progress", Res.string.in_progress)
  map.put("lang_english", Res.string.lang_english)
  map.put("lang_hindi", Res.string.lang_hindi)
  map.put("licenses_desc", Res.string.licenses_desc)
  map.put("licenses_title", Res.string.licenses_title)
  map.put("message_no_sessions", Res.string.message_no_sessions)
  map.put("notes_action_image", Res.string.notes_action_image)
  map.put("notes_action_scan", Res.string.notes_action_scan)
}
